<script>
  /* eslint-disable */
import Vue from "vue";
import { ApiCalls } from "../../../../api-calls";
import UserHelper from "../../../../utils/user-helper";
import store from "../../../../store";

export default Vue.extend({
  components: {
    AuthLoader: () => import("../../components/auth-loader/auth-loader.vue")
  },
  name: "Initialize",
  created() {
    this._initialize();
  },
  methods: {
    async _initialize() {
      try {
        const { data } = await ApiCalls.azureSignIn(0);
        if (data && data.length && data[0].Username && data[0].Username.length) {
          //UserHelper.setUserInfo(data[0]);
          this.$store.commit("SET_ACTIVE_USERNAME", data[0].Username);
        }
        if (UserHelper.checkIfHasPosAdminAccess()) {
            // pos admin
            this.$router.push("/pos-admin/manage-clinics");
          } else {
            // Not a pos admin
            this.$router.push("/admin/dashboard");
          }
      } catch (error) {
        console.log("error", error);
      }
    }
  },
  render() {
    return <auth-loader />;
  }
});
</script>
